import { render, staticRenderFns } from "./advChannelMmpSummary.vue?vue&type=template&id=1f1c6b74&scoped=true"
import script from "./advChannelMmpSummary.vue?vue&type=script&lang=js"
export * from "./advChannelMmpSummary.vue?vue&type=script&lang=js"
import style0 from "./advChannelMmpSummary.vue?vue&type=style&index=0&id=1f1c6b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c6b74",
  null
  
)

export default component.exports